import request from '../../../shared/request'

export function getJobSitePurchaseOrders(job_id) {
  return request(`/job/job_site_purchase_orders/${job_id}/`)
}

export function getPurchaseOrderByOrganizationId(organizationId) {
  return request(`/job/job_site_purchase_orders/${organizationId}/organization`)
}

export function createJobSitePurchaseOrder(payload) {
  return request(`/job/job_site_purchase_orders/${payload.job_site_purchase_order_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobSitePurchaseOrder(payload) {
  return request(`/job/job_site_purchase_orders/${payload.job_site_purchase_order_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSitePurchaseOrder(payload) {
  return request(`/job/job_site_purchase_orders/${payload.job_site_purchase_order_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getPurchaseOrder(purchaseOrderId) {
  return request(`/vendor/purchase_orders/${purchaseOrderId}/legacy`)
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSitePurchaseOrders.js